import { parseToHtml } from '@finn/ui-utils';
import React, { useState } from 'react';

import { CategoryData } from '~/types/cosmicModules';

import SpacingBox from '../SpacingBox';
import CategoryCard from './CategoryCard';

type Props = {
  title: string;
  availableCartypes: string[];
  categories: CategoryData[];
};

const CategoriesBanner: React.FunctionComponent<Props> = ({
  title,
  availableCartypes,
  categories,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [touchedIndex, setTouchedIndex] = useState(-1);
  const availableCategories = categories.filter((category) =>
    availableCartypes
      .map((cartype) => cartype.toLowerCase())
      .includes(category.slug)
  );

  if (!availableCategories.length) return null;

  const handleEvent = (event: React.SyntheticEvent, index: number) => {
    if (event.type === 'click' || event.type === 'mouseenter') {
      setSelectedIndex(index);
      setTouchedIndex(index);
    }
    if (event.type === 'mouseleave') {
      setSelectedIndex(-1);
      setTouchedIndex(-1);
    }
    if (event.type === 'touchstart') {
      setTouchedIndex(index);
    }
    if (event.type === 'touchend' || event.type === 'touchcancel') {
      setTouchedIndex(-1);
    }
  };

  return (
    <SpacingBox>
      <div className="container contain-content">
        <p className="mobile-t2-semibold md:web-t2-semibold mb-12">
          {parseToHtml(title)}
        </p>
        <div className="flex flex-col sm:flex-row sm:flex-wrap sm:justify-between md:flex-nowrap">
          {availableCategories.map((category: CategoryData, index: number) => (
            <CategoryCard
              key={category?.title}
              isSelected={index === selectedIndex}
              isTouched={index === touchedIndex}
              title={category?.metadata?.title ?? ''}
              subtitle={category?.metadata?.content ?? ''}
              photo={category?.metadata?.photo}
              href={category?.metadata?.href ?? ''}
              backgroundColor={category?.metadata?.background_color}
              href_content={category?.metadata?.href_content}
              onEvent={(event) => handleEvent(event, index)}
            />
          ))}
        </div>
      </div>
    </SpacingBox>
  );
};

export default CategoriesBanner;
